import React from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import { BrandsEnum } from "../../enums";
import { useTheme, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { Theme } from "../../.themes";

const useStyles = makeStyles((theme: Theme) => ({
  ActionButton: {
    ...theme.Site?.Button,
  },
  TextButton: {
    ...theme.Site?.TextButton,
  },
}));

export const PrimaryButton = (props: ButtonProps) => {
  const css = useStyles();
  return (
    <Button {...props} color='primary' variant='contained' className={clsx(props.className, css.ActionButton)}>
      {props.children}
    </Button>
  );
};

export const SecondaryButton = (props: ButtonProps) => {
  const theme: Theme = useTheme();
  const css = useStyles(theme);

  let buttonVariant: "contained" | "outlined" = "contained";
  switch (theme.brand) {
    case BrandsEnum.Audi:
    case BrandsEnum.Kia:
    case BrandsEnum.Volkswagen:
    case BrandsEnum.Volkswagentransportbilar:
    case BrandsEnum.Volvia:
    case BrandsEnum.Porsche:
    case BrandsEnum.Mercedes:
    case BrandsEnum.Skoda:
    case BrandsEnum.IfRullaVidare:
    case BrandsEnum.Bmw:
      buttonVariant = "outlined";
      break;
  }

  return (
    <Button {...props} color='secondary' variant={buttonVariant} className={clsx(props.className, css.ActionButton)}>
      {props.children}
    </Button>
  );
};

export const TextButton = (props: ButtonProps) => {
  const css = useStyles();
  return (
    <Button color='default' {...props} variant='text' className={clsx(props.className, css.TextButton)}>
      {props.children}
    </Button>
  );
};
